module.exports = __webpack_public_path__ + "9656f71fdfa21b5b6eb2a9ec5d9e695f.png";